import SvgQuote from '@sats-group/icons/36/quote';
import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import DynamicImage from '../dynamic-image/dynamic-image';
import { type Quote as Props, themes, variants } from './quote.types';

const Quote: React.FunctionComponent<Props> = ({
  additionalInfo,
  background,
  focusable,
  image,
  quote,
  quoteTextWeightBold,
  signature,
  tall,
  theme = background === 'dark' ? themes.featured : themes.primary,
  variant = variants.imageRight,
}) => (
  <div
    className={cn('quote', {
      'quote--theme-primary': theme === themes.primary,
      'quote--theme-secondary': theme === themes.secondary,
      'quote--theme-featured': theme === themes.featured,
      'quote--variant-image-left': variant === variants.imageLeft,
      'quote--variant-image-right': variant === variants.imageRight,
      'quote--variant-center-align-content':
        variant === variants.centerAlignContent,
      'quote--tall': tall,
    })}
    tabIndex={focusable ? 0 : undefined}
  >
    <div className="quote__content">
      {image && variant !== variants.centerAlignContent ? (
        <div className="quote__image">
          <DynamicImage
            {...image}
            aspectRatio="cropped-image--square"
            defaultHeight={280}
            defaultWidth={280}
          />
        </div>
      ) : null}
      <div className="quote__text">
        <div className="quote__icon" aria-hidden>
          <SvgQuote />
        </div>
        <blockquote className="quote__quote">
          <Text
            size={tall ? Text.sizes.headline3 : Text.sizes.headline2}
            theme={
              quoteTextWeightBold ? Text.themes.emphasis : Text.themes.normal
            }
            elementName="p"
          >
            {quote}
          </Text>
        </blockquote>
        <div className="quote__signature">
          {image ? (
            <div className="quote__avatar">
              <DynamicImage
                {...image}
                aspectRatio="cropped-image--square"
                defaultHeight={56}
                defaultWidth={56}
              />
            </div>
          ) : null}
          <div className="quote__signature-text">
            <Text
              className="quote__name"
              size={Text.sizes.basic}
              theme={Text.themes.emphasis}
            >
              {signature}
            </Text>
            {additionalInfo ? (
              <Text
                className="quote__additional-info"
                size={Text.sizes.small}
                theme={Text.themes.normal}
              >
                {additionalInfo}
              </Text>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Quote;
